// A'gong Contact — Form & Channels — scroll animations
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-cf]')) return;

  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-agong-cf-anim]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-agong-cf-anim]').forEach(function (el) { el.classList.add('is-visible'); });
  }
});
